module.exports = __webpack_public_path__ + "img/verify_email.3acd84a4.svg";